import React from "react";

export const PrimaryAISparkleIcon: React.FC<{
  size?: number;
}> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id="paint0_linear_613_7433"
        x1={-9.22136}
        y1={7.99979}
        x2={12.577}
        y2={14.7513}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3551F3" />
        <stop offset={0.552257} stopColor="#3551F3" />
        <stop offset={0.729303} stopColor="#627CFF" />
        <stop offset={0.797321} stopColor="#8476FA" />
        <stop offset={0.893793} stopColor="#64ABF4" />
        <stop offset={0.963141} stopColor="#1ACAF5" />
        <stop offset={1} stopColor="#1ACAF5" />
      </linearGradient>
      <clipPath id="clip0_613_7433">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>

    <g clipPath="url(#clip0_613_7433)">
      <path
        d="M13.3335 1.99984V4.6665M14.6668 3.33317H12.0002M2.66683 11.3332V12.6665M3.3335 11.9998H2.00016M6.62479 10.3332C6.56527 10.1025 6.44502 9.89191 6.27653 9.72343C6.10805 9.55495 5.8975 9.43469 5.66679 9.37517L1.57679 8.32051C1.50701 8.3007 1.4456 8.25867 1.40186 8.2008C1.35813 8.14293 1.33447 8.07238 1.33447 7.99984C1.33447 7.9273 1.35813 7.85675 1.40186 7.79888C1.4456 7.74101 1.50701 7.69898 1.57679 7.67917L5.66679 6.62384C5.89742 6.56438 6.10792 6.44422 6.27639 6.27587C6.44486 6.10751 6.56517 5.8971 6.62479 5.66651L7.67946 1.57651C7.69906 1.50645 7.74105 1.44474 7.799 1.40077C7.85696 1.35681 7.92771 1.33301 8.00046 1.33301C8.0732 1.33301 8.14395 1.35681 8.20191 1.40077C8.25987 1.44474 8.30185 1.50645 8.32146 1.57651L9.37546 5.66651C9.43497 5.89722 9.55523 6.10777 9.72371 6.27625C9.89219 6.44473 10.1027 6.56499 10.3335 6.62451L14.4235 7.67851C14.4938 7.69791 14.5558 7.73985 14.6 7.79789C14.6442 7.85594 14.6682 7.92688 14.6682 7.99984C14.6682 8.0728 14.6442 8.14374 14.6 8.20179C14.5558 8.25983 14.4938 8.30177 14.4235 8.32117L10.3335 9.37517C10.1027 9.43469 9.89219 9.55495 9.72371 9.72343C9.55523 9.89191 9.43497 10.1025 9.37546 10.3332L8.32079 14.4232C8.30118 14.4932 8.2592 14.5549 8.20124 14.5989C8.14328 14.6429 8.07254 14.6667 7.99979 14.6667C7.92704 14.6667 7.85629 14.6429 7.79834 14.5989C7.74038 14.5549 7.69839 14.4932 7.67879 14.4232L6.62479 10.3332Z"
        stroke="url(#paint0_linear_613_7433)"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
